var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 465",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 254",
    d: "M15.966 13.416h-.069a2.382 2.382 0 00-1.668.689 2.627 2.627 0 00-.791 1.873 2.56 2.56 0 105.12-.025 2.5 2.5 0 00-.593-1.782 2.775 2.775 0 00-1.999-.755z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 255",
    d: "M19.342 9.203h-6.684a3.234 3.234 0 00-3.23 3.23v7.133a3.234 3.234 0 003.23 3.23h6.684a3.234 3.234 0 003.231-3.23V12.43a3.234 3.234 0 00-3.231-3.227zm.033 10.158A4.722 4.722 0 0116 20.768a4.8 4.8 0 01-4.791-4.791 4.871 4.871 0 011.467-3.474 4.59 4.59 0 013.357-1.317 4.938 4.938 0 013.563 1.458 4.643 4.643 0 011.2 3.357 4.9 4.9 0 01-1.421 3.36zm1.152-6.9a1.031 1.031 0 111.031-1.031 1.031 1.031 0 01-1.031 1.033z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 256",
    d: "M16 0a16 16 0 1016 16A16 16 0 0016 0zm8.4 19.566a5.062 5.062 0 01-5.057 5.056h-6.684a5.062 5.062 0 01-5.056-5.056V12.43a5.062 5.062 0 015.056-5.056h6.684A5.062 5.062 0 0124.4 12.43z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.06a0b8ec1b9ee4e51a41f75225266e5e.svg";
export { ForwardRef as ReactComponent };